import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Marks } from '@services/api'

export const fetchMarks = createAsyncThunk(
  'marks/fetchMarks',
  async (params: any) => {
    const response = await Marks.fetchMarks(params)
    return response
  }
)

export const createMark = createAsyncThunk(
  'marks/createMark',
  async (params: any) => {
    const response = await Marks.createMark(params)
    return response
  }
)

export const updateMark = createAsyncThunk(
  'marks/updateMark',
  async (params: any) => {
    const response = await Marks.updateMark(params)
    return response
  }
)

export const deleteMark = createAsyncThunk(
  'marks/deleteMark',
  async (id: string) => {
    const response = await Marks.deleteMark(id)
    return response
  }
)

const initialState = {
  markList: [],
  keyword: '',
  pageIndex: 1,
  pageSize: 10,
  totalPage: 0,
  totalRecords: 0,
  selectedMark: {} as any,
  editMode: 'create' as 'create' | 'edit'
}

const marksSlice = createSlice({
  name: 'marks',
  initialState,
  reducers: {
    setKeyword: (state, action) => {
      state.keyword = action.payload
    },
    selectMark: (state, action) => {
      state.selectedMark = action.payload
      state.editMode = 'edit'
    },
    newMark: state => {
      state.editMode = 'create'
      state.selectedMark = {
        markCD: '',
        markName: '',
        description: '',
        isPublic: false,
        imageUrl: ''
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchMarks.fulfilled, (state, action) => {
      state.markList = action.payload.data
      state.pageIndex = action.payload.pageIndex
      state.pageSize = action.payload.pageSize
      state.totalPage = action.payload.totalPage
      state.totalRecords = action.payload.totalRecords
    })
  }
})

export const {
  setKeyword,
  selectMark,
  newMark
} = marksSlice.actions

export default marksSlice.reducer
